<div class="main-content table-page table-page--compact table-page--dense menu-page">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Menú del sistema</h1>
        <p>Arrastre las opciones entre grupos y ordénelas. Lo que guarde lo ven todas las empresas al volver a entrar.</p>
      </div>
      <div class="table-page__toolbar-actions">
        <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
                [disabled]="cargando || guardando" (click)="abrirNuevo()">
          <span class="material-icons">create_new_folder</span>
          Nuevo grupo
        </button>
        <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
                [disabled]="!hayCambios || guardando" (click)="descartar()">
          <span class="material-icons">undo</span>
          Descartar
        </button>
        <button type="button" mat-raised-button class="btn table-page__primary-btn"
                [disabled]="!hayCambios || guardando || gruposSinNombre" (click)="guardar()">
          <span class="material-icons">save</span>
          {{ guardando ? "Guardando…" : "Guardar" }}
        </button>
      </div>
    </section>

    <div class="table-page__empty table-page__empty--loading" *ngIf="cargando">
      <span class="material-icons">hourglass_top</span>
      <h3>Consultando el menú</h3>
      <p>Espere un momento.</p>
    </div>

    <div class="table-page__empty" *ngIf="!cargando && error">
      <span class="material-icons">lock</span>
      <h3>No se pudo abrir el menú</h3>
      <p>{{ error }}</p>
    </div>

    <ng-container *ngIf="!cargando && !error">
      <!-- Grupo nuevo -->
      <section class="table-page__card menu-page__nuevo" *ngIf="nuevo">
        <label class="menu-page__campo menu-page__campo--ancho">
          <span>Nombre del grupo</span>
          <input #nombreGrupo type="text" [(ngModel)]="nuevo.nombre" placeholder="Por ejemplo: Calidad" (keyup.enter)="crearGrupo()" />
        </label>
        <label class="menu-page__campo">
          <span>Icono <em class="menu-page__ayuda">(Material Icons)</em></span>
          <span class="menu-page__icono-con-vista">
            <span class="material-icons">{{ nuevo.icono || "folder" }}</span>
            <input type="text" [(ngModel)]="nuevo.icono" placeholder="folder" />
          </span>
        </label>
        <label class="menu-page__campo">
          <span>Sitio <em class="menu-page__ayuda">(si queda vacío)</em></span>
          <select [(ngModel)]="nuevo.sitio">
            <option *ngFor="let sitio of sitios" [value]="sitio">{{ sitio }}</option>
          </select>
        </label>
        <label class="menu-page__campo menu-page__campo--check">
          <input type="checkbox" [(ngModel)]="nuevo.fijo" />
          <span>Fijo abajo del menú</span>
        </label>
        <div class="menu-page__nuevo-acciones">
          <button type="button" class="menu-page__boton-texto" (click)="nuevo = null">Cancelar</button>
          <button type="button" class="menu-page__boton-texto menu-page__boton-texto--primario"
                  [disabled]="!nuevo.nombre.trim()" (click)="crearGrupo()">Agregar</button>
        </div>
      </section>

      <p class="menu-page__estado" [class.menu-page__estado--cambios]="hayCambios">
        <span class="material-icons">{{ hayCambios ? "edit_note" : "check_circle" }}</span>
        <ng-container *ngIf="hayCambios">Cambios sin guardar.</ng-container>
        <ng-container *ngIf="!hayCambios">Sin cambios.</ng-container>
        {{ principales.length + fijos.length }} grupos · {{ totalHojas }} opciones.
        <span *ngIf="gruposSinNombre" class="menu-page__estado-aviso">Hay un grupo sin nombre.</span>
      </p>

      <!-- Sin grupo -->
      <section class="table-page__card menu-page__huerfanas" *ngIf="sinGrupo">
        <header class="menu-page__grupo-cabecera">
          <span class="material-icons menu-page__grupo-icono">help_outline</span>
          <span class="menu-page__grupo-nombre">Sin grupo</span>
          <span class="menu-page__grupo-nota">Opciones cuyo grupo ya no existe: arrástrelas a uno para que vuelvan a verse.</span>
        </header>
        <ul class="menu-page__hojas" cdkDropList [id]="'hojas-' + sinGrupo.uid" [cdkDropListData]="sinGrupo.hojas"
            [cdkDropListConnectedTo]="idsListasDeHojas" [cdkDropListEnterPredicate]="nuncaRecibe"
            (cdkDropListDropped)="soltarHoja($event)">
          <li class="menu-page__hoja" *ngFor="let hoja of sinGrupo.hojas; trackBy: rastroHoja" cdkDrag [cdkDragData]="hoja">
            <ng-container *ngTemplateOutlet="renglonHoja; context: { $implicit: hoja }"></ng-container>
          </li>
        </ul>
      </section>

      <!-- Grupos del menú -->
      <h2 class="menu-page__seccion">Grupos del menú</h2>
      <div class="menu-page__grupos" cdkDropList id="grupos-principales" cdkDropListOrientation="mixed"
           [cdkDropListData]="principales" [cdkDropListConnectedTo]="['grupos-fijos']" (cdkDropListDropped)="soltarGrupo($event)">
        <ng-container *ngFor="let grupo of principales; trackBy: rastro">
          <ng-container *ngTemplateOutlet="tarjetaGrupo; context: { $implicit: grupo }"></ng-container>
        </ng-container>
        <p class="menu-page__vacio" *ngIf="principales.length === 0">Sin grupos. Arrastre uno de los fijos o cree uno nuevo.</p>
      </div>

      <!-- Fijos -->
      <h2 class="menu-page__seccion">
        Fijos abajo del menú
        <span class="menu-page__seccion-nota">Van separados de los grupos, al pie: Configuración, Consola.</span>
      </h2>
      <div class="menu-page__grupos menu-page__grupos--fijos" cdkDropList id="grupos-fijos" cdkDropListOrientation="mixed"
           [cdkDropListData]="fijos" [cdkDropListConnectedTo]="['grupos-principales']" (cdkDropListDropped)="soltarGrupo($event)">
        <ng-container *ngFor="let grupo of fijos; trackBy: rastro">
          <ng-container *ngTemplateOutlet="tarjetaGrupo; context: { $implicit: grupo }"></ng-container>
        </ng-container>
        <p class="menu-page__vacio" *ngIf="fijos.length === 0">Nada fijo. Arrastre un grupo aquí o use el pin de su tarjeta.</p>
      </div>
    </ng-container>
  </div>
</div>

<!-- Tarjeta de grupo: se arrastra desde el asa; sus hojas se arrastran solas. -->
<ng-template #tarjetaGrupo let-grupo>
  <article class="menu-page__grupo table-page__card" cdkDrag [cdkDragData]="grupo"
           [class.menu-page__grupo--vacio]="grupo.hojas.length === 0" [class.menu-page__grupo--editando]="enEdicion(grupo)">
    <header class="menu-page__grupo-cabecera">
      <span class="material-icons menu-page__asa" cdkDragHandle title="Arrastrar para ordenar">drag_indicator</span>
      <span class="material-icons menu-page__grupo-icono">{{ grupo.icono || "folder" }}</span>

      <ng-container *ngIf="!enEdicion(grupo)">
        <span class="menu-page__grupo-nombre" (dblclick)="editar(grupo)">{{ grupo.nombre || "(sin nombre)" }}</span>
        <span class="menu-page__chip" *ngFor="let sitio of grupo.sitios">{{ sitio }}</span>
        <span class="menu-page__conteo">{{ grupo.hojas.length }}</span>
      </ng-container>

      <span class="menu-page__edicion" *ngIf="enEdicion(grupo)">
        <input type="text" class="menu-page__edicion-nombre" [(ngModel)]="grupo.nombre" placeholder="Nombre" aria-label="Nombre" (keyup.enter)="terminarEdicion()" />
        <input type="text" class="menu-page__edicion-icono" [(ngModel)]="grupo.icono" placeholder="icono" aria-label="icono" (keyup.enter)="terminarEdicion()" />
        <button type="button" class="table-page__action-btn" title="Listo" aria-label="Listo" (click)="terminarEdicion()">
          <span class="material-icons">check</span>
        </button>
      </span>

      <span class="menu-page__grupo-acciones" *ngIf="!enEdicion(grupo)">
        <button type="button" class="table-page__action-btn" title="Renombrar o cambiar icono" aria-label="Renombrar" (click)="editar(grupo)">
          <span class="material-icons">edit</span>
        </button>
        <button type="button" class="table-page__action-btn" [class.menu-page__fijado]="esFijo(grupo)"
                [title]="esFijo(grupo) ? 'Volver a los grupos' : 'Fijar abajo del menú'" [attr.aria-label]="esFijo(grupo) ? 'Volver a los grupos' : 'Fijar abajo'"
                (click)="alternarFijo(grupo)">
          <span class="material-icons">push_pin</span>
        </button>
        <button type="button" class="table-page__action-btn table-page__action-btn--danger" *ngIf="grupo.hojas.length === 0"
                title="Quitar grupo" aria-label="Quitar grupo" (click)="quitarGrupo(grupo)">
          <span class="material-icons">delete</span>
        </button>
      </span>
    </header>

    <ul class="menu-page__hojas" cdkDropList [id]="'hojas-' + grupo.uid" [cdkDropListData]="grupo.hojas"
        [cdkDropListConnectedTo]="idsListasDeHojas" (cdkDropListDropped)="soltarHoja($event)">
      <li class="menu-page__hoja" *ngFor="let hoja of grupo.hojas; trackBy: rastroHoja" cdkDrag [cdkDragData]="hoja"
          [class.menu-page__hoja--editando]="enEdicion(hoja)">
        <ng-container *ngTemplateOutlet="renglonHoja; context: { $implicit: hoja }"></ng-container>
      </li>
      <li class="menu-page__soltar" *ngIf="grupo.hojas.length === 0">Suelte opciones aquí</li>
    </ul>
  </article>
</ng-template>

<!-- Renglón de opción -->
<ng-template #renglonHoja let-hoja>
  <span class="material-icons menu-page__asa" title="Arrastrar">drag_indicator</span>
  <span class="material-icons menu-page__hoja-icono">{{ hoja.icono || "label" }}</span>

  <span class="menu-page__hoja-cuerpo" *ngIf="!enEdicion(hoja)">
    <span class="menu-page__hoja-nombre" (dblclick)="editar(hoja)">{{ hoja.nombre }}</span>
    <span class="menu-page__hoja-meta">
      <code>{{ hoja.factory }}</code>
      <span class="menu-page__chip">{{ hoja.sitio }}</span>
      <span class="menu-page__perfiles" [class.menu-page__sin-perfiles]="!hoja.perfiles" [title]="etiquetaPerfiles(hoja)">
        <span class="material-icons">{{ hoja.perfiles ? "group" : "group_off" }}</span>{{ hoja.perfiles || 0 }}
      </span>
    </span>
  </span>

  <span class="menu-page__edicion menu-page__hoja-cuerpo" *ngIf="enEdicion(hoja)">
    <input type="text" class="menu-page__edicion-nombre" [(ngModel)]="hoja.nombre" placeholder="Nombre" aria-label="Nombre" (keyup.enter)="terminarEdicion()" />
    <input type="text" class="menu-page__edicion-icono" [(ngModel)]="hoja.icono" placeholder="icono" aria-label="icono" (keyup.enter)="terminarEdicion()" />
    <button type="button" class="table-page__action-btn" title="Listo" aria-label="Listo" (click)="terminarEdicion()">
      <span class="material-icons">check</span>
    </button>
  </span>

  <button type="button" class="table-page__action-btn menu-page__hoja-editar" *ngIf="!enEdicion(hoja)"
          title="Renombrar o cambiar icono" aria-label="Renombrar" (click)="editar(hoja)">
    <span class="material-icons">edit</span>
  </button>
</ng-template>
